<template>
	<div>
		<i-head-top></i-head-top>

		<div class="userHeader">
			<div class="container fc-bet">
				<router-link to="index" class="logo fc">
					<img src="../assets/logo-shop.png" alt="" srcset="" width="184" style="max-height: 50px; width: 122px;">
				</router-link>
				<div class="funs flex1 fc">
					<a href="#/">首页</a>
					<a href="#/baseInfo">个人中心</a>
				</div>
				<div v-if="!isIntegralUser" class="shopCar fcc">
          <router-link to="cart">
					<a href="" class="car-shop fcc">
						<i></i>
						购物车
						<span class="cart-count">{{ cartNum }}</span>
					</a>
          </router-link>
				</div>

			</div>
		</div>
	</div>
</template>

<script>
import currentUser from '@/mixins/current-user'
	import {cartCount} from '@/api/cart'
  import { mapGetters, mapMutations } from 'vuex'
  import { getToken } from '@/axios/cookies'
  import { clearUserInfo, getStoredUserInfo, hasUserIdentity } from '@/utils/auth'
  export default {
  mixins: [currentUser],
		name: 'login-after-head-center',
		data() {

			return {
        status: 0
			}
		},
    computed: {
      ...mapGetters([
        'cartNum', // 购物车商品数量
        'userInfo'
      ])
    },
		methods: {
      ...mapMutations({
        setCartNum: 'SET_CARTNUM' // 修改vuex购物车数量
      }),
      // 获取购物车商品数量
      async getCartNum () {
        const res = await cartCount()
        if (res.status === 200) {
          this.setCartNum(res.data.count)
        } else {
          this.$message.warning(res.msg)
        }
      },
      isLogin () {
        const userInfo = this.userInfo || getStoredUserInfo()
        this.status = getToken() && hasUserIdentity(userInfo) ? 1 : 0
      }
		},
		mounted() {
      this.isLogin()
      if (this.status) {
        if (!this.isIntegralUser) this.getCartNum()
      } else {
        clearUserInfo()
      }
		}

	}
</script>
<style scoped lang="less">


</style>

